// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "398bbc00ac504426","396": "9c6f0bab4dfa1027","460": "470b1abcb1f9db0c","917": "ef8da0d0316da280","985": "5b428ec5ffea88ef",}[chunkId] + ".chunk.js"
}